import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import NotFound from 'components/NotFound';
import EntityEditPageSkeleton from 'components/EntityEditPageSkeleton';
import FormSkeleton from 'components/FormSkeleton';
import PageWithSidebar from 'components/PageWithSidebar';
import EntitySidebar from 'components/EntitySidebar';
import RoomPropertyEditForm from 'components/RoomPropertyEditForm';

import { withData } from 'lib';
import { SettingsRoomPropertyEditPageQuery } from '__generated__/SettingsRoomPropertyEditPageQuery.graphql';

const query = graphql`
  query SettingsRoomPropertyEditPageQuery($id: ID!) {
    roomProperty(id: $id) {
      name
      etgKey

      ...EntitySidebar_entity
      ...RoomPropertyEditForm_roomProperty
    }
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<SettingsRoomPropertyEditPageQuery>;
};

type RouteParams = {
  id: string;
};

const breadcrumbs = [
  { link: '/settings', name: 'Nustatymai' },
  { link: '/settings/room-properties', name: 'Kambarių savybės' },
];

const SettingsRoomPropertyEditPage: FC<Props> = ({ preloadedQuery }) => {
  const { roomProperty } = usePreloadedQuery<SettingsRoomPropertyEditPageQuery>(
    query,
    preloadedQuery
  );

  if (!roomProperty) {
    return <NotFound />;
  }

  return (
    <PageWithSidebar
      sidebar={<EntitySidebar entity={roomProperty} />}
      breadcrumbs={[
        ...breadcrumbs,
        {
          name: roomProperty.name ?? `[${roomProperty.etgKey}]`,
        },
      ]}>
      <RoomPropertyEditForm roomProperty={roomProperty} />
    </PageWithSidebar>
  );
};

export default withData<SettingsRoomPropertyEditPageQuery, RouteParams>({
  query,

  loading: (
    <EntityEditPageSkeleton breadcrumbs={breadcrumbs}>
      <FormSkeleton sections={1} />
    </EntityEditPageSkeleton>
  ),

  variables: ({ routeParams }) => ({
    id: routeParams.id,
  }),
})(SettingsRoomPropertyEditPage);
